<template>
  <div class="container-fluid px-3 d-flex justify-content-between align-items-center">
    <ul class="nav nav-underline justify-content-start mb-0">
      <li class="nav-item">
        <a class="nav-link link-secondary" :class="{active: (page == 'orders' || page == 'OrderDetail')}" aria-current="page"
          @click="switchPage('orders')" href="#">Orders</a>
      </li>
      <li class="nav-item">
        <a class="nav-link link-secondary" :class="{active: (page == 'orderbevestigingen' || page == 'OrderBevestigingDetail')}"
          @click="switchPage('orderbevestigingen')" href="#">Orderbevestigingen</a>
      </li>
      <li class="nav-item">
        <a class="nav-link link-secondary" :class="{active: (page == 'invoices' || page == 'InvoiceDetail')}"
          @click="switchPage('invoices')" href="#">Facturen</a>
      </li>
    </ul>

    <!-- Detailnavigatie (vorige/volgende/positie/terug) hoort bij de actieve
         detailpagina en wordt hier rechts getoond zodat hij niet meeschuift met
         pagina-specifieke knoppen (bijv. de PDF-toggle) in de detailheader. -->
    <DetailNavigation
      v-if="detailItemType"
      :key="detailItemType"
      :itemType="detailItemType"
      buttonClass="btn-outline-primary"
    />
  </div>
</template>

<script>
import OAuth2AzureService from '@/services/OAuth2AzureService';
import DetailNavigation from './DetailNavigation.vue';

export default {
  name: "PageTabs",
  components: { DetailNavigation },
  props: {
    currentPage: {
      type: String,
      required: true
    }
  },
  emits: ['switchPage'],
  data() {
    return {
      page: '',
      authService: null,
    }
  },
  computed: {
    // Bepaalt op basis van de actieve route welk itemType de detailnavigatie
    // moet tonen. null = geen detailpagina actief -> navigatie niet tonen.
    detailItemType() {
      const map = {
        OrderDetail: 'order',
        InvoiceDetail: 'invoice',
        OrderBevestigingDetail: 'orderConfirmation',
      };
      return map[this.$route.name] || null;
    }
  },
  async created() {
    this.authService = new OAuth2AzureService();
  },
  watch: {
    currentPage(newValue) {
      if(!newValue) return;
      console.log('currentPage changed to: ', newValue)
      this.page = newValue
    }
  },
  methods: {
    switchPage(pageName) {
      this.$emit('switchPage', pageName)
      setTimeout(() => {
        this.page = pageName
      }, 200)
    }
  }
}
</script>
